var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfile2User = function SvgProfile2User(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.107 7.247a1.2 1.2 0 0 0-.22 0A2.947 2.947 0 0 1 3.04 4.294c0-1.634 1.32-2.96 2.96-2.96a2.957 2.957 0 0 1 .107 5.913M10.94 2.667A2.33 2.33 0 0 1 13.273 5c0 1.26-1 2.287-2.247 2.333a.8.8 0 0 0-.173 0M2.773 9.707c-1.613 1.08-1.613 2.84 0 3.913 1.834 1.227 4.84 1.227 6.674 0 1.613-1.08 1.613-2.84 0-3.913-1.827-1.22-4.834-1.22-6.674 0M12.227 13.334c.48-.1.933-.294 1.306-.58 1.04-.78 1.04-2.067 0-2.847a3.3 3.3 0 0 0-1.286-.573"
  })));
};
export default SvgProfile2User;